function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { Component, createRef } from 'react';
import _ from 'underscore';
import HitsOverview from './hits_overview';
import LengthDistribution from './length_distribution'; // length distribution of hits
import Utils from './utils';
import { fastqToFasta } from './fastq_to_fasta';
import CollapsePreferences from './collapse_preferences';
import './jquery_world';

/**
 * Query component displays query defline, graphical overview, length
 * distribution, and hits table.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ReportQuery = /*#__PURE__*/function (_Component) {
  function ReportQuery() {
    _classCallCheck(this, ReportQuery);
    return _callSuper(this, ReportQuery, arguments);
  }
  _inherits(ReportQuery, _Component);
  return _createClass(ReportQuery, [{
    key: "shouldComponentUpdate",
    value:
    // Each update cycle will cause all previous queries to be re-rendered.
    // We avoid that by implementing shouldComponentUpdate life-cycle hook.
    // The trick is to simply check if the components has recieved props
    // before.
    function shouldComponentUpdate() {
      // If the component has received props before, query property will
      // be set on it. If it is, we return false so that the component
      // is not re-rendered. If the query property is not set, we return
      // true: this must be the first time react is trying to render the
      // component.
      return !this.props.query;
    }
    // Kind of public API //

    /**
     * Returns the id of query.
     */
  }, {
    key: "domID",
    value: function domID() {
      return 'Query_' + this.props.query.number;
    }
  }, {
    key: "queryLength",
    value: function queryLength() {
      return this.props.query.length;
    }

    /**
     * Returns number of hits.
     */
  }, {
    key: "numhits",
    value: function numhits() {
      return this.props.query.hits.length;
    }
  }, {
    key: "headerJSX",
    value: function headerJSX() {
      var meta = "Length: ".concat(this.queryLength().toLocaleString());
      if (this.props.showQueryCrumbs) {
        meta = "query ".concat(this.props.query.number, ". ").concat(meta);
      }
      return /*#__PURE__*/_jsxs("div", {
        className: "section-header border-b border-seqorange justify-between w-full flex flex-col sm:flex-row gap-4",
        children: [/*#__PURE__*/_jsxs("h3", {
          className: "text-base cursor-pointer flex flex-col sm:flex-row items-start",
          children: [/*#__PURE__*/_jsxs("strong", {
            children: ["Query=", /*#__PURE__*/_jsx("span", {
              className: "ml-1",
              children: this.props.query.id
            })]
          }), /*#__PURE__*/_jsx("span", {
            className: "ml-1",
            children: this.props.query.title
          })]
        }), /*#__PURE__*/_jsx("span", {
          className: "label first-letter:capitalize text-sm text-right font-normal text-inherit pt-0 px-0",
          children: meta
        })]
      });
    }
  }, {
    key: "hitsListJSX",
    value: function hitsListJSX() {
      return /*#__PURE__*/_jsxs("div", {
        className: "pt-0 px-0 pb-px",
        children: [/*#__PURE__*/_jsx(HitsOverview, {
          query: this.props.query,
          program: this.props.program,
          collapsed: this.props.veryBig
        }, 'GO_' + this.props.query.number), /*#__PURE__*/_jsx(LengthDistribution, {
          query: this.props.query,
          algorithm: this.props.program
        }, 'LD_' + this.props.query.id), /*#__PURE__*/_jsx(HitsTable, {
          query: this.props.query,
          imported_xml: this.props.imported_xml
        }, 'HT_' + this.props.query.number)]
      });
    }
  }, {
    key: "noHitsJSX",
    value: function noHitsJSX() {
      return /*#__PURE__*/_jsx("div", {
        className: "pt-0 px-0 pb-px",
        children: /*#__PURE__*/_jsx("strong", {
          children: " ****** No BLAST hits found ****** "
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsxs("div", {
        className: "resultn mt-1.5",
        id: this.domID(),
        "data-query-len": this.props.query.length,
        "data-algorithm": this.props.program,
        children: [this.headerJSX(), this.numhits() && this.hitsListJSX() || this.noHitsJSX()]
      });
    }
  }]);
}(Component);

/**
 * Query widget for Search component.
 */
export var SearchQueryWidget = /*#__PURE__*/function (_Component2) {
  function SearchQueryWidget(props) {
    var _this;
    _classCallCheck(this, SearchQueryWidget);
    _this = _callSuper(this, SearchQueryWidget, [props]);
    _this.state = {
      value: $('input#input_sequence').val() || ''
    };
    _this.value = _this.value.bind(_this);
    _this.clear = _this.clear.bind(_this);
    _this.focus = _this.focus.bind(_this);
    _this.isEmpty = _this.isEmpty.bind(_this);
    _this.textarea = _this.textarea.bind(_this);
    _this.controls = _this.controls.bind(_this);
    _this.handleInput = _this.handleInput.bind(_this);
    _this.hideShowButton = _this.hideShowButton.bind(_this);
    _this.indicateError = _this.indicateError.bind(_this);
    _this.indicateNormal = _this.indicateNormal.bind(_this);
    _this.type = _this.type.bind(_this);
    _this.guessSequenceType = _this.guessSequenceType.bind(_this);
    _this.preProcessSequence = _this.preProcessSequence.bind(_this);
    _this.notify = _this.notify.bind(_this);
    _this.textareaRef = /*#__PURE__*/createRef();
    _this.controlsRef = /*#__PURE__*/createRef();
    return _this;
  }

  // LIFECYCLE Methods
  _inherits(SearchQueryWidget, _Component2);
  return _createClass(SearchQueryWidget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      $('body').click(function () {
        $('[data-notifications] [data-role=notification].active').hide('drop', {
          direction: 'up'
        }).removeClass('active');
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.hideShowButton();
      this.preProcessSequence();
      this.props.onSequenceChanged(this.residuesCount());
      var type = this.type();
      if (!type || type !== this._type) {
        this._type = type;
        this.notify(type);
        this.props.onSequenceTypeChanged(type);
      }
    }

    // Kind of public API. //

    /**
     * Returns query sequence if no argument is provided (or null or undefined
     * is provided as argument). Otherwise, sets query sequence to the given
     * value and returns `this`.
     *
     * Default/initial state of query sequence is an empty string. Caller must
     * explicitly provide empty string as argument to "reset" query sequence.
     */
  }, {
    key: "value",
    value: function value(val) {
      if (val == null) {
        // i.e., val is null or undefined
        return this.state.value;
      } else {
        this.setState({
          value: val
        });
        return this;
      }
    }
  }, {
    key: "residuesCount",
    value: function residuesCount() {
      var sequence = this.value();
      var lines = sequence.split('\n');
      var residuesCount = lines.reduce(function (count, line) {
        if (!line.startsWith('>')) {
          return count + line.length;
        }
        return count;
      }, 0);
      return residuesCount;
    }

    /**
     * Clears textarea. Returns `this`.
     *
     * Clearing textarea also causes it to be focussed.
     */
  }, {
    key: "clear",
    value: function clear() {
      return this.value('').focus();
    }

    /**
     * Focuses textarea. Returns `this`.
     */
  }, {
    key: "focus",
    value: function focus() {
      this.textarea().focus();
      return this;
    }

    /**
     * Returns true if query is absent ('', undefined, null), false otherwise.
     */
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return !this.value();
    }

    // Internal helpers. //
  }, {
    key: "textarea",
    value: function textarea() {
      return $(this.textareaRef.current);
    }
  }, {
    key: "controls",
    value: function controls() {
      return $(this.controlsRef.current);
    }
  }, {
    key: "handleInput",
    value: function handleInput(evt) {
      this.value(evt.target.value);
    }

    /**
     * Hides or shows 'clear sequence' button.
     *
     * Rendering the 'clear sequence' button takes into account presence or
     * absence of a scrollbar.
     *
     * Called by `componentDidUpdate`.
     */
  }, {
    key: "hideShowButton",
    value: function hideShowButton() {
      if (!this.isEmpty()) {
        // Calculation below is based on -
        // http://chris-spittles.co.uk/jquery-calculate-scrollbar-width/
        // FIXME: can reflow be avoided here?
        var textareaNode = this.textarea()[0];
        var sequenceControlsRight = textareaNode.offsetWidth - textareaNode.clientWidth;
        this.controls().css('right', sequenceControlsRight + 17);
        this.controls().removeClass('hidden');
      } else {
        // FIXME: what are lines 1, 2, & 3 doing here?
        this.textarea().parent().removeClass('has-error');
        this.$sequenceFile = $('#sequence-file');
        this.$sequenceFile.empty();
        this.controls().addClass('hidden');
      }
    }

    /**
     * Put red border around textarea.
     */
  }, {
    key: "indicateError",
    value: function indicateError() {
      this.textarea().parent().addClass('has-error');
    }

    /**
     * Put normal blue border around textarea.
     */
  }, {
    key: "indicateNormal",
    value: function indicateNormal() {
      this.textarea().parent().removeClass('has-error');
    }

    /**
     * Returns type of the query sequence (nucleotide, protein, mixed).
     *
     * Query widget supports executing a callback when the query type changes.
     * Components interested in query type should register a callback instead
     * of directly calling this method.
     */
  }, {
    key: "type",
    value: function type() {
      var sequence = this.value().trim();
      // FASTQ detected, but we don't know if conversion has succeeded yet
      // will notify separately if it does
      if (sequence.startsWith('@')) {
        return undefined;
      }
      var sequences = sequence.split(/>.*/);
      var type, tmp;
      for (var i = 0; i < sequences.length; i++) {
        tmp = this.guessSequenceType(sequences[i]);

        // could not guess the sequence type; try the next sequence
        if (!tmp) {
          continue;
        }
        if (!type) {
          // successfully guessed the type of atleast one sequence
          type = tmp;
        } else if (tmp !== type) {
          // user has mixed different type of sequences
          return 'mixed';
        }
      }
      return type;
    }
  }, {
    key: "preProcessSequence",
    value: function preProcessSequence() {
      var sequence = this.value();
      var updatedSequence = fastqToFasta(sequence);
      if (sequence !== updatedSequence) {
        this.value(updatedSequence);
        this.notify('fastq');
      }
    }

    /**
     * Guesses and returns the type of the given sequence (nucleotide,
     * protein).
     */
  }, {
    key: "guessSequenceType",
    value: function guessSequenceType(sequence) {
      // remove 'noisy' characters
      sequence = sequence.replace(/[^A-Z]/gi, ''); // non-letter characters
      sequence = sequence.replace(/[NX]/gi, ''); // ambiguous  characters

      // can't determine the type of ultrashort queries
      if (sequence.length < 10) {
        return undefined;
      }

      // count the number of putative NA
      var putative_NA_count = 0;
      for (var i = 0; i < sequence.length; i++) {
        if (sequence[i].match(/[ACGTU]/i)) {
          putative_NA_count += 1;
        }
      }
      var threshold = 0.9 * sequence.length;
      return putative_NA_count > threshold ? 'nucleotide' : 'protein';
    }
  }, {
    key: "notify",
    value: function notify(type) {
      this.indicateNormal();
      clearTimeout(this.notification_timeout);
      // $('[data-notifications] [data-role=notification].active').hide().removeClass('active');

      if (type) {
        $('#' + type + '-sequence-notification').show('drop', {
          direction: 'up'
        }).addClass('active');
        this.notification_timeout = setTimeout(function () {
          $('[data-notifications] [data-role=notification].active').hide('drop', {
            direction: 'up'
          }).removeClass('active');
        }, 5000);
        if (type === 'mixed') {
          this.indicateError();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsxs("div", {
        className: "relative",
        children: [/*#__PURE__*/_jsx("div", {
          className: "sequence",
          children: /*#__PURE__*/_jsx("textarea", {
            id: "sequence",
            ref: this.textareaRef,
            className: "block w-full p-4 text-gray-900 border border-gray-300 rounded-l-lg rounded-tr-lg bg-gray-50 text-sm font-mono min-h-52 resize-y",
            name: "sequence",
            value: this.state.value,
            rows: "6",
            required: "required",
            placeholder: "Paste query sequence(s) or drag file containing query sequence(s) in FASTA format here ...",
            spellCheck: "false",
            autoFocus: true,
            onChange: this.handleInput
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "hidden absolute top-2 right-2",
          ref: this.controlsRef,
          children: /*#__PURE__*/_jsxs("button", {
            type: "button",
            className: "border border-gray-300 rounded bg-white hover:bg-gray-200",
            id: "btn-sequence-clear",
            title: "Clear query sequence(s).",
            onClick: this.clear,
            children: [/*#__PURE__*/_jsx("span", {
              id: "sequence-file"
            }), /*#__PURE__*/_jsx("i", {
              className: "fa fa-times w-6 h-6 p-1"
            }), /*#__PURE__*/_jsx("span", {
              className: "sr-only",
              children: "Clear query sequence(s)."
            })]
          })
        })]
      });
    }
  }]);
}(Component);

/**
 * Renders summary of all hits per query in a tabular form.
 */
var HitsTable = /*#__PURE__*/function (_Component3) {
  function HitsTable(props) {
    var _this2;
    _classCallCheck(this, HitsTable);
    _this2 = _callSuper(this, HitsTable, [props]);
    _this2.name = 'Hit sequences producing significant alignments';
    _this2.collapsePreferences = new CollapsePreferences(_this2);
    _this2.state = {
      collapsed: _this2.collapsePreferences.preferenceStoredAsCollapsed()
    };
    return _this2;
  }
  _inherits(HitsTable, _Component3);
  return _createClass(HitsTable, [{
    key: "tableJSX",
    value: function tableJSX() {
      var hasName = _.every(this.props.query.hits, function (hit) {
        return hit.sciname !== '';
      });

      // Width of sequence column is 55% when species name is not shown and
      // query coverage is.
      var seqwidth = 55;
      // If we are going to show species name, then reduce the width of
      // sequence column by the width of species column.
      if (hasName) seqwidth -= 15;
      // If we are not going to show query coverage (i.e. for imported XML),
      // then increase the width of sequence column by the width of coverage
      // column.
      if (this.props.imported_xml) seqwidth += 15;
      return /*#__PURE__*/_jsxs("table", {
        className: "table table-hover table-condensed tabular-view text-sm min-w-full mb-0",
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            className: "text-neutral-500",
            children: [/*#__PURE__*/_jsx("th", {
              className: "text-left font-normal",
              children: "#"
            }), /*#__PURE__*/_jsx("th", {
              style: {
                width: "".concat(seqwidth, "%")
              },
              className: "text-left font-normal",
              children: "Similar sequences"
            }), hasName && /*#__PURE__*/_jsx("th", {
              className: "text-left font-normal w-2/12",
              children: "Species"
            }), !this.props.imported_xml && /*#__PURE__*/_jsx("th", {
              className: "text-right font-normal w-2/12",
              children: "Query coverage (%)"
            }), /*#__PURE__*/_jsx("th", {
              className: "text-right font-normal w-1/12",
              children: "Total score"
            }), /*#__PURE__*/_jsx("th", {
              className: "text-right font-normal w-1/12",
              children: "E value"
            }), /*#__PURE__*/_jsx("th", {
              className: "text-right font-normal w-1/12",
              children: "Identity (%)"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: _.map(this.props.query.hits, _.bind(function (hit) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                className: "text-left",
                children: hit.number + '.'
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsxs("a", {
                  href: '#Query_' + this.props.query.number + '_hit_' + hit.number,
                  className: "text-sm text-seqblue hover:text-seqorange cursor-pointer pe-1 line-clamp-1 tooltip-item",
                  title: "".concat(hit.id, " ").concat(hit.title),
                  children: [hit.id, " ", hit.title]
                })
              }), hasName && /*#__PURE__*/_jsx("td", {
                className: "pe-1 line-clamp-1 tooltip-item",
                title: hit.sciname,
                children: hit.sciname
              }), !this.props.imported_xml && /*#__PURE__*/_jsx("td", {
                className: "text-right",
                children: hit.qcovs
              }), /*#__PURE__*/_jsx("td", {
                className: "pe-1 text-right",
                children: hit.total_score
              }), /*#__PURE__*/_jsx("td", {
                className: "pe-1 text-right",
                children: Utils.inExponential(hit.hsps[0].evalue)
              }), /*#__PURE__*/_jsx("td", {
                className: "pe-1 text-right",
                children: Utils.inPercentage(hit.hsps[0].identity, hit.hsps[0].length)
              })]
            }, hit.number);
          }, this))
        })]
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/_jsxs("div", {
        className: "table-hit-overview ".concat(this.state.collapsed ? 'print:hidden' : ''),
        children: [/*#__PURE__*/_jsx("div", {
          className: "grapher-header pr-px",
          children: /*#__PURE__*/_jsxs("h4", {
            className: "inline-block pl-px m-0 caption cursor-pointer text-sm caption",
            onClick: function onClick() {
              return _this3.collapsePreferences.toggleCollapse();
            },
            children: [this.collapsePreferences.renderCollapseIcon(), /*#__PURE__*/_jsxs("span", {
              children: [" ", this.name]
            })]
          })
        }), /*#__PURE__*/_jsx("div", {
          id: 'Query_' + this.props.query.number + 'HT_' + this.props.query.number,
          className: "overflow-auto md:overflow-hidden",
          children: !this.state.collapsed && this.tableJSX()
        })]
      });
    }
  }]);
}(Component);